export default "__VITE_PUBLIC_ASSET__defcd360__"